"use client";

import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  value: 450,
  suffix: "+",
  label: "PROJECTS COMPLETED",
  description: "Complex global operations delivered with precision and technical excellence."
}, {
  value: 32,
  suffix: "",
  label: "COUNTRIES REACHED",
  description: "Active logistics networks spanning across major international trade hubs."
}, {
  value: 98,
  suffix: "%",
  label: "CLIENT RETENTION",
  description: "Long-term partnerships built on trust, transparency, and seamless execution."
}, {
  value: 12,
  suffix: "B",
  label: "ASSETS MANAGED",
  description: "Total value of infrastructure and resources under our strategic coordination."
}];
const AnimatedNumber = ({
  value,
  isVisible
}: {
  value: number;
  isVisible: boolean;
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number;
    const duration = 2000;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(easeProgress * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(animate);
  }, [value, isVisible]);
  return <>{count.toLocaleString()}</>;
};
export default function ImpactByTheNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="223893" id="global-impact" className="relative py-24 overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/global_wireframe_map.png)] bg-cover bg-center opacity-[0.08] pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Global Impact by the Numbers
          </h2>
          <p className="text-lg text-secondary font-default">
            Quantifiable excellence in project management and international logistics coordination.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {statsData.map((stat, i) => <div data-index={i} key={i}>
              <Card className="h-full bg-white/[0.03] backdrop-blur-md border-white/5 shadow-none hover:border-primary/40 transition-all duration-500 rounded-sm">
                <CardContent className="p-8 flex flex-col items-center text-center justify-center h-full">
                  <div className="text-4xl md:text-5xl font-bold font-mono text-foreground mb-3 flex items-baseline drop-shadow-[0_0_15px_rgba(0,183,255,0.3)]">
                    <AnimatedNumber value={stat.value} isVisible={isVisible} />
                    <span>{stat.suffix}</span>
                  </div>
                  <h3 className="text-sm font-bold font-default text-primary mb-2 tracking-widest uppercase">
                    {stat.label}
                  </h3>
                  <p className="text-sm text-secondary font-default leading-relaxed">
                    {stat.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}